import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPulse = () => {
  return (
    <g>
      <path d="m9.0752 15.5062h-.0185a.725.725 0 0 1 -.6953-.6l-1.7755-10.1436-1.582 6.5a.7237.7237 0 0 1 -.5879.5444.7143.7143 0 0 1 -.7295-.33l-1.5565-2.4752h-1.3a.7251.7251 0 0 1 0-1.45h1.7a.7228.7228 0 0 1 .6133.3394l.8577 1.3621 1.997-8.2051a.7246.7246 0 0 1 1.418.0464l1.7529 10.0137 1.6885-7.4136a.7252.7252 0 0 1 1.3779-.1147l1.6309 3.9688h1.3038a.7251.7251 0 0 1 0 1.45h-1.79a.7262.7262 0 0 1 -.6709-.45l-.9464-2.3018-1.98 8.6953a.7249.7249 0 0 1 -.7075.5639z" />
    </g>
  );
};

export default withIcon(IconPulse);
